import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { AppThunk } from 'store/types';
import { StructurePilotsStore, IPilot } from 'pages/ApartmentStatus/types';

const initialState: StructurePilotsStore = {
  pilots: [],
  loading: false,
};

const reset: CaseReducer<StructurePilotsStore> = () => initialState;

const structurePilots: CaseReducer<StructurePilotsStore, PayloadAction<string[]>> = (
  state,
  action,
) => {
  state.pilots = action.payload;
};

const loading: CaseReducer<StructurePilotsStore, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

export const structurePilotsSlice = createSlice({
  name: 'structurePilots',
  initialState,
  reducers: {
    structurePilots,
    loading,
    reset,
  },
});

export const {
  structurePilots: setStructurePilots,
  loading: setLoading,
  reset: setOvpReset,
} = structurePilotsSlice.actions;

// список пилотов объекта
export const getStructurePilots =
  (structureId: string | number | true | (string | number | boolean | null)[]): AppThunk =>
  dispatch => {
    get<IPilot>(`/api/standards/structures/${structureId}/pilots/`).then(({ data }) => {
      dispatch(setStructurePilots(data.pilots));
    });
  };
